const STORAGE_KEY = "omsOrderList";

export function loadOrdersFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = JSON.parse(raw || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveOrdersToStorage(orders) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(orders));
}
